import { vec2 } from "@tlaukkan/tsm";
import { Not, System } from "ecsy";
import { TaggedVirus, Collision, Tagger, Virus, Cytokine, Slowed, SuspendMovement, Targeting, RangeType, Transform, Dead, Submerged, Bullet, AimForDirection } from "../components";
import { BehaviorsConstants, CollisionCategory } from "../constants";
import { destroyEntity, getId } from "../entityFactory";
import { Game } from "../game";
import { addComponent } from "../utils";

/**Kind of a catch all system for different entity behaviors. Consider seperateing into smaller systems later */
export class TaggingSystem extends System {
	game: Game;

	constructor(world: any, attributes: any) {
		// @ts-ignore
		super(world, attributes);
		this.game = attributes.game;
	}

	init() { }

	execute(delta: number) {
		if (!this.game.inSimulation) return;

		this.queries.tagging.results.forEach(entity => {
			const collision = entity.getComponent(Collision);
			for (const hit of collision.collidedWith) {
				if (hit.entity.hasComponent(Virus) && !hit.entity.hasComponent(TaggedVirus)) {
					//Tag and self destruct
					addComponent(hit.entity, TaggedVirus);
					addComponent(hit.entity, SuspendMovement, { duration: BehaviorsConstants.TagProteinSuspendTime }); //freeze movement for 1 second.
					if (entity.hasComponent(Cytokine)) {
						//Consumed when it tags a virus
						destroyEntity(entity);
					}
					break;
				}
			}
		});

		this.queries.taggedVirus.added?.forEach(entity => {
			const taggedVirus = entity.getComponent(TaggedVirus);
			const targeting = addComponent(entity, Targeting);
			const range = BehaviorsConstants.TagProteinAttractRange;
			const targetId = targeting.addSpec(RangeType.Circle, range, CollisionCategory.Cytokine, range, false, false);
			taggedVirus.bulletTargetingId = targetId;
		});

		for (const entity of this.queries.taggedVirus.results) {
			const targeting = entity.getComponent(Targeting);
			if (!targeting) continue;

			const taggedVirus = entity.getComponent(TaggedVirus);
			const transform = entity.getComponent(Transform);

			const hits = targeting.getTargets(taggedVirus.bulletTargetingId);
			for (const hit of hits) {
				if (!hit.hasComponent(Bullet) || !hit.hasComponent(Transform)) continue;
				const bullet = hit.getComponent(Bullet);
				if (bullet.taggedTargetVirus !== null && bullet.taggedTargetVirus !== entity) continue;

				//OPT: Would be better if this switched to AimForTarget, as its basically recreating that wastefully with no lead correction here.
				//Just needs way to make sure the direction aiming comes back afterward
				const bulletTranform = hit.getComponent(Transform);
				const bulletAim = hit.getComponent(AimForDirection);
				if (!bulletAim) { continue; } //shouldn't happen but apparently can?
				if (!bulletAim.fixedDirection) bulletAim.fixedDirection = new vec2([0, 0]);
				vec2.direction(transform.position, bulletTranform.position, bulletAim.fixedDirection);
			};
		}
	}
}

TaggingSystem.queries = {
	tagging: { components: [Collision, Tagger] },
	taggedVirus: { components: [TaggedVirus, Transform], listen: { added: true } },
}


